module.exports = __webpack_public_path__ + "static/scale-model-of-aventura-slide-tower-in-miami-gardens-florida-a8c918d52ef12585cb5b5dfbc79e29bd.png";